<template>
  <b-tag :type="statusColor" size="is-small">
    {{ statusIcon }} {{ status }}
  </b-tag>
</template>

<script>
import { ContentStatus } from "vue-chess-shared";

export default {
  name: "TopicStatusBadge",

  props: {
    status: {
      type: String,
      required: true,
      validator: (value) => Object.values(ContentStatus).includes(value),
    },
  },

  computed: {
    statusColor() {
      const colors = {
        [ContentStatus.Draft]: "is-light",
        [ContentStatus.Published]: "is-success is-light",
        [ContentStatus.Archived]: "is-dark is-light",
      };
      return colors[this.status] || "is-light";
    },

    statusIcon() {
      const icons = {
        [ContentStatus.Draft]: "📝", // pencil for draft
        [ContentStatus.Published]: "📢", // star for published
        [ContentStatus.Archived]: "📦", // package for archived
      };
      return icons[this.status] || "❔"; // question mark for unknown status
    },
  },
};
</script>
